import { ensureHttpsUrl } from "@/lib/utils";

/**
 * Builds a safe avatar source URL with optional cache-busting.
 * - Normalizes URLs to HTTPS
 * - Skips cache-busting for signed URLs (S3 presigned URLs)
 * - Only adds cache-buster when provided and URL is not signed
 */
export function buildAvatarSrc(
  profilePictureUrl: string | null | undefined,
  cacheBuster: number | null = null,
): string | null {
  if (!profilePictureUrl) {
    return null;
  }

  const raw = ensureHttpsUrl(profilePictureUrl);
  if (!raw) {
    return null;
  }

  // Detect signed URLs (S3 presigned URLs contain these patterns)
  const isSigned = /X-Amz-|Signature=|Key-Pair-Id=|Policy=/.test(raw);

  // Only add cache-buster if:
  // 1. Cache buster is provided
  // 2. URL is not signed (signed URLs break if we modify them)
  if (!isSigned && cacheBuster) {
    const separator = raw.includes("?") ? "&" : "?";
    return `${raw}${separator}v=${cacheBuster}`;
  }

  return raw;
}
